export interface Response<T> {
  data: T
}

export interface IParams {
  sort?: string,
  order?: string,
  search?: string,
  take?: number,
  page?: number,
  filters?: any,
  active?: boolean;
}

export const DEFAULT_ITEMS_PARAMS: IParams = {
  sort: '',
  order: '',
  search: '',
  take: 25,
  page: 1,
  filters: {},
};
